import React from 'react';
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import styles from './styles.scss';

export interface FAQSectionTwoProps {
  localizeMessage: (key: string) => string;
}

export const FAQSectionTwo: React.FC<FAQSectionTwoProps> = ({ localizeMessage }) => (
  <Box mt={2}>
    <Typography
      variant="h6"
      style={{ fontWeight: 600 }}
      color="textSecondary"
      gutterBottom
      className={styles['faq-section-title']}
    >
      {localizeMessage('faqSectionAbonnemangshjalpen')}
    </Typography>
    <div className={styles.faqCard}>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="subtitle1" className={styles['faq-question']}>
            {localizeMessage('faqQ5')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <div>
            <Typography style={{ marginBottom: 8 }} className={styles['faq-answer']}>
              {localizeMessage('faqA5_intro')}
            </Typography>
            <ol style={{ margin: 0, paddingLeft: 20, marginBottom: 12 }}>
              <li className={styles['faq-answer']}>{localizeMessage('faqA5_1')}</li>
              <li className={styles['faq-answer']}>{localizeMessage('faqA5_2')}</li>
              <li className={styles['faq-answer']}>{localizeMessage('faqA5_3')}</li>
              <li className={styles['faq-answer']}>{localizeMessage('faqA5_4')}</li>
            </ol>
            <Typography style={{ marginBottom: 8 }} className={styles['faq-answer']}>
              {localizeMessage('faqA5_submit_intro')}
            </Typography>
            <ol style={{ margin: 0, paddingLeft: 20, marginBottom: 12 }}>
              <li className={styles['faq-answer']}>{localizeMessage('faqA5_5')}</li>
              <li className={styles['faq-answer']}>{localizeMessage('faqA5_6')}</li>
              <li className={styles['faq-answer']}>{localizeMessage('faqA5_7')}</li>
              <li className={styles['faq-answer']}>{localizeMessage('faqA5_8')}</li>
            </ol>
          </div>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="subtitle1" className={styles['faq-question']}>
            {localizeMessage('faqQ6')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className={styles['faq-answer']}>{localizeMessage('faqA6')}</Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="subtitle1" className={styles['faq-question']}>
            {localizeMessage('faqQ7')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className={styles['faq-answer']}>{localizeMessage('faqA7')}</Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="subtitle1" className={styles['faq-question']}>
            {localizeMessage('faqQ8')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <div>
            <ol style={{ margin: 0, paddingLeft: 20, marginBottom: 8 }}>
              <li className={styles['faq-answer']}>{localizeMessage('faqA8_1')}</li>
              <li className={styles['faq-answer']}>{localizeMessage('faqA8_2')}</li>
              <li className={styles['faq-answer']}>{localizeMessage('faqA8_3')}</li>
              <li className={styles['faq-answer']}>{localizeMessage('faqA8_4')}</li>
            </ol>
            <Typography style={{ fontStyle: 'italic', marginBottom: 12 }}>{localizeMessage('faqA8_note')}</Typography>
          </div>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="subtitle1" className={styles['faq-question']}>
            {localizeMessage('faqQ9')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className={styles['faq-answer']}>{localizeMessage('faqA9')}</Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="subtitle1" className={styles['faq-question']}>
            {localizeMessage('faqQ10')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className={styles['faq-answer']}>{localizeMessage('faqA10')}</Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  </Box>
);
